module.exports = __webpack_public_path__ + "static/media/ee_phone.d4d35db0.svg";